import log from 'loglevel';

if (process.env.REACT_APP_DEBUG_LEVEL) {
  log.setDefaultLevel(log.levels.DEBUG);
} else {
  log.setDefaultLevel(log.levels.WARN);
}

export {log as logger};
